import { Component, Inject, Optional, OnInit, ViewChild, Input, EventEmitter, Output, HostListener, ViewChildren, QueryList, AfterViewInit, AfterViewChecked, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { collapsibleTabla } from './collapsible.animation';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { HttpService } from '../http.service';
import { InputBS } from '../inputbs';
import { NumformPipe } from '@tres-erres/ngx-utils';
import { merge } from 'rxjs/internal/observable/merge';
import { startWith, switchMap, map, catchError } from 'rxjs/operators';
import { ColumnaTabla, TablaPrefs } from './interfaces';
import { ComponentesService } from '../componentes.service';
import { Accion } from '../interfaces';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Autocomplete } from '../autocomplete';
import { ChipSelected } from '../busca-chips/busca-chips.component';
import { throwError } from 'rxjs';
import { UtilService } from '@app/core';
import { MatCard } from '@angular/material';

export const BASE_URL = '';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-tabla',
	templateUrl: './tabla.component.html',
	styleUrls: ['./tabla.component.scss'],
	animations: [ collapsibleTabla ],
	encapsulation: ViewEncapsulation.None
})
export class Tabla implements OnInit, AfterViewInit, AfterViewChecked {
	chipList: ChipSelected[];
	constructor(
		private httpService: HttpService,
		private utilService: UtilService,
		private componentesService: ComponentesService,
		private fb: FormBuilder,
		@Optional() @Inject('baseUrl') private baseUrl: string,
		private bottomSheet: MatBottomSheet
	) {
		if (!this.httpService['baseUrl'] && (!this.baseUrl || this.baseUrl.length === 0)) {
			throw new Error('No está definida la constante baseUrl');
		} else {
			if (this.baseUrl && this.baseUrl.length > 0) {
				this.httpService['baseUrl'] = this.baseUrl;
			}
			this.actualizarHeaders();
		}
	}
	card = null;
	inicializado = false;
	headers = [];
	dataSource = new MatTableDataSource();
	resultsLength = 0;
	isLoading = false;
	browserRequest;
	itemsSeleccionados = { ids: [], denominacion: [] };
	columna = null;
	direccion = null;
	permisos: any = {};
	filtraFormGroup: FormGroup;
	expandedElement = [];
	expandedOverElement = [];
	formControlName = 'buscar';

	txtSinResultados = 'No records to display';

	@Input() nombreDatos = 'todos';

	@Input() nombreCuantas = 'cuantas';

	/** Definición de columnas de tabla primaria */
	@Input() columnas: ColumnaTabla[] = [];

	/** Resultados por página */
	@Input() cuantos = 10;

	/** Ruta query. Ej: admin/hojear/usuarios */
	@Input() url = '';

	/** Si está contenido en un sidenav, por scrolling */
	@Input() sidenav = false;

	/** Si cambia pagina al mover la rueda */
	@Input() scrollable = true;

	/** Si se utiliza un disparador personalizado para expandir el detalle */
	@Input() detalleCustomTrigger = false;

	/** Si hace efecto al hover y busca detalle */
	@Input() detalla = false;

	/** Si hace efecto al hover y busca detalle */
	@Input() detallaOver = false;

	/** Si se detalla, esta es la estructura de la subtabla */
	@Input() columnasSubtabla: ColumnaTabla[] = [];

	/** Si se detallaOver, esta es la estructura de la subtabla */
	@Input() columnasSubtablaOver: ColumnaTabla[] = [];

	/** Array de acciones de la subtabla */
	@Input() accionesSubtabla: Accion[] = [];

	/** Array de acciones en el footer de la tabla para cuando tengo seleccion */
	@Input() accionesFooter: Accion[] = [];

	/** Si realiza las peticiones por POST, caso contrario, GET */
	@Input() post = true;

	@Input() mostrarPeso = false;

	/** Permite desactivar la ordenacion de la tabla */
	@Input() sortable = true;

	/** Formulario personalizado para el buscador */
	@Input() customFormGroup: FormGroup;

	/** Deshabilita el buscador por defecto */
	@Input() ocultaBuscador = false;

	/** Placeholder del campo de búsqueda */
	@Input() placeholder = 'Search...';

	/** Array de resultados predefinidos, comunmente utilizados para cuando chips es true */
	@Input() resultadosChips: any[] = [];

	/** Cantidad de caracteres minimos necesarios para que el autocomplete arroje resultados */
	@Input() min = 1;

	/** Configura la búsqueda por chips */
	@Input() chips = false;

	/** Si muestra checkbox y emite eventos */
	@Input() selecciona = false;

	/** Si el elemento es seleccionable */
	@Input() seleccionaSi: (element: any) => boolean;

	/** Nombre del campo que referencia al id. Ej: "ctid" */
	@Input() nombreCampoId = 'id';

	/** Nombre del campo que referencia al nombre. Ej: "ctnombre" */
	@Input() nombreCampoDenominacion = 'denominacion';

	/** Retornar el objeto completo al seleccionar  */
	@Input() retornarObjetoCompleto = false;

	/** "Elementos seleccionados": 1 */
	@Input() nombreElementosSeleccionados = 'Elementos seleccionados';

	/** Array de acciones (tabla primaria) */
	@Input() acciones: Accion[] = [];

	/** Si muestra un toggle como acción en cada fila  */
	@Input() toggle = null;

	/** Define la cantidad de iconos a mostrar antes de agrupar */
	@Input() maxIconosVisibles ? = 4;

	/** Define la clase de tabla fija */
	@Input() tablaFija ? = true;

	/** Define si muestra el paginador */
	@Input() mostrarPaginador ? = true;

	/** Emite evento cada vez que cambian los itemsSeleccionados */
	@Output() seleccion = new EventEmitter();

	/** Emite evento cada vez que cambia el datasource del data-table */
	@Output() actualizacion = new EventEmitter();

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('filtraAutocomplete', { static: true }) filtraAutocomplete: Autocomplete;
	@ViewChild('contextDetails', { static: true }) contextDetails: MatCard;
	@ViewChildren(MatMenuTrigger) matMenuTriggers: QueryList<MatMenuTrigger>;
	/** Función que brinda el componente padre para modificar los datos al refrescar */
	@Input() modificarDatos: Function = (datos) => datos;

	/** Función que brinda el componente padre para obtener los parámetros de la query */
	@Input() getDatos: Function = () => Object.create({});

	/** Formatea la respuesta que llega de la petición */
	@Input() formateaRespuesta: Function = (data) => data;

	/** Función que brinda el componente padre para obtener los parámetros de la query */
	@Input() buscarDetalle: Function = (): Promise<void> => new Promise(resolve => { resolve(); });

	ngOnInit() {
		this.inicializado = this.columnas && this.columnas.length > 0;

		// inicializamos el formulario del buscador (filtros)
		this.filtraFormGroup = this.fb.group({
			buscar: new FormControl(null)
		});
	}

	async ngAfterViewInit() {
		await this.ngAfterViewChecked();
		return;
	}

	async ngAfterViewChecked() {
		return;
	}

	init(datos: TablaPrefs) {
		return new Promise<void>(resolve => {
			// this.isLoading = true;
			this.ngAfterViewInit().then(() => {
				this.actualizarDatos(datos, false);

				// cargamos las columnas segun cookies
				this.cargarColumnas();

				if (!this.url || this.url == '') {
					this.setDatos();
					this.inicializado = true;
					resolve();
					return;
				}
				merge(this.paginator.page)
				.pipe(
					startWith({}),
					switchMap(() => {
						this.isLoading = true;
						const data = this.setDatos();
						let req: Promise<any>;
						if (this.post) {
							req = this.httpService.post(this.url, data);
						} else {
							req = this.httpService.get(this.url, data);
						}
						return req;
					}),
					map((data: any) => {
						data = this.formateaRespuesta(data);
						this.isLoading = false;
						if (data) {
							this.resultsLength = (this.nombreCuantas && data[this.nombreCuantas]) ? data[this.nombreCuantas] : (data.cuantas ? data.cuantas : 0);
							this.permisos = data.permisos ? data.permisos : {};
							return this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
						} else {
							console.error('No hubo respuesta del servidor');
							return [];
						}
					}), catchError(err => {
						this.isLoading = false;
						throw err;
					})
				).subscribe(datos => {
					datos = datos ? this.modificarDatos(datos) : [];
					if (datos.length < this.cuantos && datos.length > 0) {
						this.dataSource.data = this.rellenar(datos);
					} else {
						this.dataSource.data = datos;
					}
					this.inicializado = true;
					resolve();
				});
			});
		});
	}

	/**
	 * quepagina: a que página ir.
	 *
	 */

	irPagina(quepagina) {
		this.paginator.pageIndex = quepagina;
	}

	actualizarDatos(datos, refresh?: boolean) {
		for (const key in datos) {
			if (datos.hasOwnProperty(key)) {
				const dato = datos[key];
				this[key] = dato;
			}
		}
		this.firstPage();
		if (refresh === false) {
			return;
		}
		if (this.inicializado) {
			this.refreshTable(false);
		}
	}

	actualizarHeaders() {
		// vemos si existe una columna de selección
		let hayColumnaSeleccion = false;
		let indexColumnaSeleccion = 0;
		for (let i = 0; i < this.columnas.length; i++) {
			if (this.columnas[i].def == 'seleccion') { hayColumnaSeleccion = true; }
			indexColumnaSeleccion = i;
			break;
		}

		if (this.selecciona && !hayColumnaSeleccion) {
			this.columnas.unshift({def: 'seleccion', nombre: 'Selección', tipo: null});
		} else if (!this.selecciona && hayColumnaSeleccion) {
			// elimino la columna de selección
			this.columnas.splice(indexColumnaSeleccion, 1);
		}

		this.headers = this.columnas.map((columna) => {
			return columna.def;
		});
		this.cargarAnchos();
	}

	setDatos() {
		const datos = this.getDatos();

		if (!datos.cuantos) {
			datos.cuantos = this.cuantos;
		}

		if (this.chipList && this.chipList.length > 0) {
			datos.chips = this.chipList;
		}
		if (!datos.texto) {
			// Esto deberá pasar a ser entradas de un formulario.
			// Por defecto tenemos una entrada, pero podrían ser varias.
			// Decidimos dejar a que el backend se encargue y solamente le pasamos el objeto value del formGroup
			// fix cuando post es false y se hace la peticion por GET
			if (this.customFormGroup) {
				datos.texto = Object.assign({}, JSON.parse(JSON.stringify(this.customFormGroup.value)));
			} else {
				datos.texto = this.filtraFormGroup.value.buscar;
			}
		}
		if (this.paginator) {
			datos.pag = this.paginator.pageIndex;
			if (this.paginator.pageSize != datos.cuantos) {
				datos.cuantos = this.paginator.pageSize;
			}
		} else {
			datos.pag = 0;
		}
		datos.columna = this.columna;
		datos.direccion = this.direccion;
		this.actualizarHeaders();
		return datos;
	}

	refreshTable(saltear_espera?: Boolean) {
		return new Promise<void>(resolve => {
			this.isLoading = true;
			clearTimeout(this.browserRequest);
			this.browserRequest = setTimeout(() => {
				let req: Promise<any>;
				if (this.post) {
					req = this.httpService.post(this.url, this.setDatos());
				} else {
					const dat = this.setDatos();
					req = this.httpService.get(this.url, dat);
				}
				req.then(data => {
					data = this.formateaRespuesta(data);
					this.resultsLength = this.nombreCuantas ? data[this.nombreCuantas] : (data.cuantas ? data.cuantas : 0);
					this.permisos = data.permisos ? data.permisos : {};
					data = this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
					data = data ? this.modificarDatos(data) : [];
					if (data.length < this.cuantos && data.length > 0) {
						this.dataSource.data = this.rellenar(data);
					} else {
						this.dataSource.data = data;
					}
					this.isLoading = false;
					if (this.resultsLength <= this.paginator.pageSize * this.paginator.pageIndex) {
						this.firstPage();
					}
					this.actualizacion.emit(this.dataSource.data);
					resolve();
				}).catch ((e) => {
					this.isLoading = false;
					resolve();
				});
			}, saltear_espera ? 0 : 400);
		});
	}
	chipChanges(e) {
		const valor = e[e.length - 1];
		if (this.chips && valor && !valor._deAuto) {
			this.filtraFormGroup.get('buscar').patchValue(e);
			this.refreshTable();
		}
	}
	limpiaFiltroDefault() {
		this.filtraAutocomplete.limpiar();
	}
	vaciarTabla() {
		this.dataSource.data = [];
		this.resultsLength = 0;
	}
	llenarTabla (datos: any) {
		if (datos && datos.length > 0) {
			if (datos.length < this.cuantos) {
				this.dataSource.data = this.rellenar(datos);
			} else {
				this.dataSource.data = datos;
			}
		} else {
			this.dataSource.data = [];
		}
	}
	rellenar(datos) {
		const rows = [];
		datos.forEach(element => {
			rows.push(element);
		});
		const cantidad = rows.length;
		for (let i = 0; i < (this.cuantos - cantidad); i++) {
			const obj = {};
			this.columnas.forEach(col => {
				obj[col.def] = null;
			});
			rows.push(obj);
		}
		return rows;
	}

	estaVacio(element) {
		return Object.values(element).every((item) => item === null);
	}

	cambiaOrden(event) {
		if (event.direction.length > 0) {
			this.columna = event.active;
			this.direccion = event.direction;
		} else {
			this.columna = null;
			this.direccion = null;
		}
		this.refreshTable(true);
	}

	numForm(valor, borrarceros) {
		return new NumformPipe().transform(valor, borrarceros);
	}

	comprobarPermiso(nombrePermiso): boolean {
		return this.permisos.hasOwnProperty(nombrePermiso) && this.permisos[nombrePermiso];
	}

	// Abre el menu contextual de la cabecera de la tabla
	menuHeader(columna, event) {
		event.preventDefault();
		this.matMenuTriggers.forEach((trigger) => {
			if (trigger.menuData && trigger.menuData.columna === columna) {
				trigger.openMenu();
			}
		});
	}

	modificaAncho(columna, oper, event) {
		event.stopPropagation();
		if (!columna.ancho) {
			this.columnas.forEach(col => {
				if (col !== columna) {
					col.ancho = Math.floor(100 / this.columnas.length);
				}
				this.guardaAnchos(col);
			});
			columna.ancho = Math.floor(100 / this.columnas.length) + ((oper === 'mas') ? 1 : -1);
		} else {
			columna.ancho += (oper === 'mas') ? 1 : -1;
		}
		this.guardaAnchos(columna, oper);
	}

	borraAncho(columna) {
		if (columna.ancho) {
			const anchosTablas: any = JSON.parse(localStorage.getItem('anchosTablas'));
			this.columnas.forEach(col => {
				if (col === columna) {
					if (!!anchosTablas && anchosTablas[this.url] && anchosTablas[this.url][columna.def] && anchosTablas[this.url][columna.def]['original']) {
						col.ancho = anchosTablas[this.url][columna.def]['original'];
						delete anchosTablas[this.url][columna.def];
						localStorage.setItem('anchosTablas', JSON.stringify(anchosTablas));
					}
				}
			});
		}
	}

	guardaAnchos(columna, oper?) {
		let anchosTablas: any = localStorage.getItem('anchosTablas');
		if (!anchosTablas) {
			anchosTablas = {};
		} else {
			anchosTablas = JSON.parse(anchosTablas);
		}
		this.columnas.forEach((col) => {
			if (col === columna) {
				if (!anchosTablas[this.url]) {
					anchosTablas[this.url] = {};
				}
				if (!anchosTablas[this.url][columna.def]) {
					anchosTablas[this.url][columna.def] = {};
				}
				if (!anchosTablas[this.url][columna.def]['original']) {
					anchosTablas[this.url][columna.def]['original'] = columna.ancho;
					if (oper) {
						anchosTablas[this.url][columna.def]['original'] += (oper === 'mas') ? -1 : 1;
					}
				}
				anchosTablas[this.url][columna.def]['modificado'] = columna.ancho;
			}
		});
		localStorage.setItem('anchosTablas', JSON.stringify(anchosTablas));
	}

	cargarAnchos() {
		let anchosTablas: any = localStorage.getItem('anchosTablas');
		if (!anchosTablas) {
			return;
		} else {
			anchosTablas = JSON.parse(anchosTablas);
		}
		this.columnas.forEach((col) => {
			if (anchosTablas[this.url] && anchosTablas[this.url][col.def] !== undefined) {
				col.ancho = anchosTablas[this.url][col.def]['modificado'];
			}
		});
	}

	guardaColumnas(columna) {
		let columnasTablas: any = this.utilService.getLS('columnasTablas', true);
		if (!columnasTablas) {
			columnasTablas = {};
		}
		this.columnas.forEach((col) => {
			if (col === columna) {
				if (!columnasTablas[this.url]) {
					columnasTablas[this.url] = {};
				}
				if (!columnasTablas[this.url][columna.def]) {
					columnasTablas[this.url][columna.def] = {};
				}
				if (!columnasTablas[this.url][columna.def]['original']) {
					columnasTablas[this.url][columna.def]['original'] = columna.oculta;
				}
				columnasTablas[this.url][columna.def]['modificado'] = columna.oculta;
			}
		});
		this.utilService.setLS('columnasTablas', columnasTablas, true);
	}

	cargarColumnas() {
		const columnasTablas: any = this.utilService.getLS('columnasTablas', true);
		if (!columnasTablas) {
			return;
		}
		this.columnas.forEach((col) => {
			if (columnasTablas[this.url] && columnasTablas[this.url][col.def] !== undefined) {
				col.oculta = columnasTablas[this.url][col.def]['modificado'];
			}
		});
	}

	modifica(elemento, columna) {
		elemento.editando = true;
		if (columna.modificaDatos && columna.modificaDatos.procesa) {
			elemento = columna.modificaDatos.procesa(elemento, columna);
		}
		if (elemento === false) {
			return false;
		}
		let data: any = {
			value: elemento[columna.def],
			placeholder: columna.nombre,
			tipo: 'input'
		};
		data = columna.modificaDatos && columna.modificaDatos.datosBS ? Object.assign(data, columna.modificaDatos.datosBS) : data;
		if (columna.modificaDatos && columna.modificaDatos.busca) {
			data.busca = columna.modificaDatos.busca;
			data.tipo = 'autocomplete';
		} else if (columna.modificaDatos && columna.modificaDatos.datos) {
			data.resultados = columna.modificaDatos.datos();
			data.tipo = 'autocomplete';
		}
		if (!data.nombre) {
			data.nombre = 'value';
		}
		let seCreaForm = false;
		if (!data.form) {
			seCreaForm = true;
			data.form = new FormGroup({
				value: new FormControl(null)
			});
		}
		if (!data.formControlName) {
			data.formControlName = 'value';
		}
		this.bottomSheet.open(InputBS, { data }).afterDismissed().subscribe((res) => {
			elemento.editando = false;
			if (seCreaForm && res && res.form) {
				if (typeof res.form.get('value').value == 'number' || typeof res.form.get('value').value == 'string') {
					res = { value: res.form.get('value').value };
				} else {
					res = res.form.get('value').value;
				}
			}
			if (columna.modificaDatos && columna.modificaDatos.actualiza) {
				columna.modificaDatos.actualiza(elemento, columna, res);
			}
		});
	}

	detallar(elemento, event: any) {
		if (this.detalla && !this.estaVacio(elemento)) {
			if (event !== null) {
				event.preventDefault();
			}
			if (event === null || (!event.target.className.includes('checkbox') && !event.target.className.includes('accion') && this.detalla)) {
				if (!elemento.detalles) {
					this.isLoading = true;
					this.buscarDetalle(elemento).then((detalles) => {
						if (detalles && detalles.length > 0) {
							elemento.detalles = detalles;
							if (event && event.ctrlKey) {
								this.expandedElement.push(elemento);
							} else {
								this.expandedElement = [elemento];
							}
						} else {
							elemento.detalles = [];
							this.componentesService.notification('No existe detalle para esta fila');
						}
						this.isLoading = false;
					});
				} else if (this.expandedElement.some((element) => element === elemento)) {
					if (event && event.ctrlKey) {
						this.expandedElement = this.expandedElement.filter((element) => element !== elemento);
					} else {
						this.expandedElement = [];
					}
				} else if (elemento.detalles.length > 0) {
					if (event && event.ctrlKey) {
						this.expandedElement.push(elemento);
					} else {
						this.expandedElement = [elemento];
					}
				} else {
					this.componentesService.notification('No existe detalle para esta fila');
				}
			}
		}
	}
	detallarOver(elemento, event: any) {
		if (this.detallaOver && !this.estaVacio(elemento)) {
			if (event !== null) {
				event.preventDefault();
			}
			if (event === null || (!event.target.className.includes('checkbox') && !event.target.className.includes('accion'))) {
				this.expandedOverElement = [elemento];
			}
		}
	}
	detallarLeave(elemento, event: any) {
		if (this.detallaOver && !this.estaVacio(elemento)) {
			if (event !== null) {
				event.preventDefault();
			}
			if (event === null || (!event.target.className.includes('checkbox') && !event.target.className.includes('accion'))) {
				this.expandedOverElement = [];
			}
		}
	}
	handleMouseOver(elemento, event: any) {
		// this.detallarOver(elemento, event);
	}

	handleMouseLeave(elemento, event: any) {
		// this.detallarLeave(elemento, event);
	}

	clasesRow(row) {
		const clases = {
			'fila-expandible': this.detalla,
			'fila-expandida': this.expandedElement.indexOf(row) !== -1,
			'editando': row.editando
		};
		if (row.clase) {
			if (typeof row.clase === 'string') {
				clases[row.clase] = true;
			} else {
				row.clase.forEach(element => {
					clases[element] = true;
				});
			}
		}
		return clases;
	}

	firstPage(refresh = false) {
		return new Promise<void>(resolve => {
			this.ngAfterViewInit().then(() => {
				this.paginator.pageIndex = 0;
				if (refresh) {
					this.refreshTable().then(() => resolve());
				}
			});
		});
		// this.ngAfterViewInit().then(() => {
		// 	this.paginator.firstPage();
		// });
	}
	nextPage() {
		return new Promise<void>(resolve => {
			this.ngAfterViewInit().then(() => {
				if (this.paginator.hasNextPage()) {
					this.paginator.pageIndex++;
					this.refreshTable().then(() => resolve());
				}
			});
		});
	}
	previousPage() {
		return new Promise<void>(resolve => {
			this.ngAfterViewInit().then(() => {
				if (this.paginator.hasPreviousPage()) {
					this.paginator.pageIndex--;
					this.refreshTable().then(() => resolve());
				}
			});
		});
	}

	@HostListener('wheel', ['$event']) // Firefox
	@HostListener('mousewheel', ['$event']) // Chrome
	onScroll(event) {
		if (!this.hayScroll(this.sidenav) && this.scrollable && this.expandedElement.length === 0) {
			if ((event.target.className instanceof SVGAnimatedString || this.parents(event.target, '.mat-table') || event.target.className.includes('loading')) && (!this.hayScroll() && !this.hayScroll(true))) {
				event.preventDefault();
				if (event.deltaY < 0 && this.paginator.hasPreviousPage()) {
					this.paginator.pageIndex--;
					this.refreshTable();
				} else if (event.deltaY > 0 && this.paginator.hasNextPage()) {
					event.preventDefault();
					this.paginator.pageIndex++;
					this.refreshTable();
				}
			}
		}
	}

	private hayScroll(sidenav?: boolean) {
		if (sidenav) {
			return document.querySelector('tr2-tabla').clientHeight + 64 > window.innerHeight;
		} else {
			return document.body.clientHeight > window.innerHeight;
		}
	}

	private parents(element: string | any, parent: string) {
		let el: any = typeof element === 'string' ? document.querySelector(element) : element;
		const parents = Array.from(document.querySelectorAll(parent));
		while (el.tagName !== 'HTML') {
			el = el.parentNode;
			if (parents.indexOf(el) !== -1) {
				return el;
			}
		}
		return null;
	}

	/**
	 * preSeleccionar ids
	 * @param queids : array de ids a marcar
	 */
	preSeleccionar(queids) {
		// this.itemsSeleccionados.ids = [];
		// this.itemsSeleccionados.denominacion = [];
		this.dataSource.data.forEach((element: any) => {
			if (queids.indexOf(element[this.nombreCampoId]) >= 0) {
				if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
					if (this.retornarObjetoCompleto) {
						this.itemsSeleccionados.ids.push(element);
					} else {
						this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
						this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
					}
				}
			}
		});
	}

	marcar(que) {
		if (que === 'reiniciar') {
			this.itemsSeleccionados.ids = [];
			this.itemsSeleccionados.denominacion = [];
		} else {
			if (que === 'todas') {
				const datos = this.setDatos();
				datos.ids = null;
				this.isLoading = true;
				datos.seleccionarTodas = true;
				datos.retornarObjetoCompleto = this.retornarObjetoCompleto;
				this.httpService.post(this.url, datos).then(data => {
					this.isLoading = false;
					const arrDatos = this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
					if (arrDatos) {
						arrDatos.forEach((element: any) => {
							if (this.retornarObjetoCompleto) {
								if (!this.itemsSeleccionados.ids.find(x => x[this.nombreCampoId] == element[this.nombreCampoId])) {
									this.itemsSeleccionados.ids.push(element);
								}
							} else {
								if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
									this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
									this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
								}
							}
						});
					}
				});
			} else if (que === 'pagina') {
				this.dataSource.data.forEach((element: any) => {
					if (element[this.nombreCampoId]) {
						if (this.retornarObjetoCompleto) {
							if (!this.itemsSeleccionados.ids.find ( x => x[this.nombreCampoId] == element[this.nombreCampoId])) {
								this.itemsSeleccionados.ids.push(element);
							}
						} else if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
								this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
								this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
						}
					}
				});
			}
		}
		this.seleccion.emit(this.itemsSeleccionados);
	}

	check(element: any, checked: boolean) {
		if (checked) {
			if (this.retornarObjetoCompleto) {
				this.itemsSeleccionados.ids.push(element);
			} else {
				this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
				this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
			}
		} else {
			if (this.retornarObjetoCompleto) {
				this.itemsSeleccionados.ids = this.itemsSeleccionados.ids.filter((item) => {
					return element[this.nombreCampoId] !== item[this.nombreCampoId];
				});
			} else {
				this.itemsSeleccionados.ids = this.itemsSeleccionados.ids.filter((item, index) => {
					if (element[this.nombreCampoId] === item) {
						delete this.itemsSeleccionados.denominacion[index];
					}
					return element[this.nombreCampoId] !== item;
				});
			}
		}
		this.seleccion.emit(this.itemsSeleccionados);
	}

	checked(element: any) {
		if (this.retornarObjetoCompleto) {
			return this.itemsSeleccionados.ids.find ((item) => item[this.nombreCampoId] === element[this.nombreCampoId]);
		} else {
			return this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) >= 0;
		}
	}

	preview() {
		if (this.itemsSeleccionados.ids.length > 20) {
			return '';
		} else {
			let title = '';
			this.itemsSeleccionados.denominacion.forEach(element => {
				title += element + `
`;
			});
			return title;
		}
	}

	setChips(chips: ChipSelected[]) {
		this.chipList = chips;
		this.refreshTable(true);
	}

	columnaOculta(col: ColumnaTabla): boolean {
		return (col.oculta != undefined && col.oculta != null && col.oculta == true);
	}

	iconoColumnaOculta(col: ColumnaTabla) {
		return this.columnaOculta(col) ? 'check_box_outline_blank' : 'check_box';
	}

	toggleColumna(event, col: ColumnaTabla) {
		event.stopPropagation();
		const columna = this.columnas.find(c => c.def == col.def);
		if (!!columna) {
			if (columna.oculta == undefined || columna.oculta == null || columna.oculta == false) {
				columna['oculta'] = true;
			} else {
				columna['oculta'] = false;
			}
		}
		this.guardaColumnas(columna);
	}

	get cantidadColumnasVisibles() {
		return this.columnas.filter(ele => !ele.oculta).length;
	}

	modificaTxtSinResp(txt) {
		this.txtSinResultados = txt;
	}
}
